const information = {
	elements: {
		$section: $('.js-information'),
	},

	init() {
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.$section,
				start:               'top bottom',
				end:                 `top top`,
				scrub:               true,
				invalidateOnRefresh: true,
				onUpdate:            () => {
					this.elements.$section[0].style.maskImage = 'none'
					this.elements.$section[0].offsetWidth //force a style recalculation
					this.elements.$section[0].style.maskImage = 'var(--section-mask-url, url(\'#information-mask\')), linear-gradient(transparent 0%, transparent var(--mask-position, 0%), black var(--mask-position, 0%), black 100%)'
				},
			},
		}).to(this.elements.$section, {
			'--mask-progress': 1,
		}, 0)
	},
}
export default information
